// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"5520c4c56caf10a6ec68","105":"7e45d2d895ac2ddc8934","214":"88566b24bdb727f0cfb6","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"e4f1755c1e133b8c52b0","852":"73a59c05d6788c00c419"}[chunkId] + ".bundle.js";
};